// Plain module (no "use server") so it can export non-function values.
// A "use server" file may only export async functions, so the form state
// type and its initial value live here, shared by actions.ts and the form.
import type { Ok } from "@/lib/actions/result";

/** FormState plus per-field backend validation errors on the failure side. */
export type RegisterState =
  | Ok<{ email: string; pending: boolean }>
  | { ok: false; error?: string; errors?: Record<string, string[]> };

export const initialRegisterState: RegisterState = { ok: false };
